import Button from "app/components/UI/Button";
import ImmutablePropTypes from "react-immutable-proptypes";
import PropTypes from "prop-types";
import React from "react";
import classes from "./AccountConfirm.module.css";

export const AccountConfirm = ({
  translate,
  onAccountConfirm,
  contact,
  onNotFound,
  onConfirmPayment,
  isPreparePayment,
  totalUnitCount
}) => (
  <div className={classes.accountConfirmContainer}>
    <div className={classes.accountConfirm__table}>
      <div className={classes.accountConfirm__table__header}>
        {translate("Vous venez d'être authentifié sous le nom de")}
      </div>
      <div className={classes.accountConfirm__table__content}>
        <div className={classes.accountConfirm__content__title}>
          {contact.get("givenName")} {contact.get("familyName")}
        </div>
        {contact.get("email") && (
          <div className={classes.accountConfirm__content__subtitle}>{contact.get("clubName")}</div>
        )}
      </div>
    </div>

    <div className={classes.accountConfirm__info}>
      {translate(
        "Une fois le paiement terminé, c'est bien ce compte qui sera crédité avec les unités achetées durant la vente."
      )}
    </div>


    {totalUnitCount > parseInt(process.env.REACT_APP_COUNTER_UNIT_LIMIT)  && (  // eslint-disable-line
      <div className={classes.accountConfirm__count_limit}>
      {translate(
        `Un compte practice Bluegreen ne peut excéder ${process.env.REACT_APP_COUNTER_UNIT_LIMIT} unités. Veuillez s’il vous plaît vérifier votre solde et renouveler l’opération.`
      )}
    </div>
    )}

    <Button
      onClick={onConfirmPayment}
      className={classes.accountConfirm__btn}
      primary
      disabled={isPreparePayment || totalUnitCount > parseInt(process.env.REACT_APP_COUNTER_UNIT_LIMIT)}  // eslint-disable-line
      label={translate("Confirmer ce compte & payer")}
      fullWidth
    />

    <Button.Flat
      onClick={onNotFound}
      className={classes.accountConfirm__btn}
      secondary
      label={translate("Ce n'est pas mon profil")}
      fullWidth
    />
  </div>
);

AccountConfirm.propTypes = {
  translate: PropTypes.func.isRequired,
  contact: ImmutablePropTypes.map.isRequired,
  onNotFound: PropTypes.func.isRequired,
  isPreparePayment: PropTypes.bool.isRequired,
  onConfirmPayment: PropTypes.func.isRequired
};

export default AccountConfirm;



// WEBPACK FOOTER //
// ./src/app/components/CheckoutAccount/AccountConfirm/AccountConfirm.js